import { render } from "./TheA01WhatsNewNoticePanel.vue?vue&type=template&id=bb5230bc&scoped=true&ts=true"
import script from "./TheA01WhatsNewNoticePanel.vue?vue&type=script&lang=ts"
export * from "./TheA01WhatsNewNoticePanel.vue?vue&type=script&lang=ts"

import "./TheA01WhatsNewNoticePanel.vue?vue&type=style&index=0&id=bb5230bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5230bc"]])

export default __exports__